import React from 'react';

const ProgressBar = ({ current, total }) => {
  return (
    <div className="progress-bar">
      {[...Array(total)].map((_, i) => (
        <div key={i} className={`progress-segment ${i < current ? 'active' : ''}`}></div>
      ))}
    </div>
  );
};

export default ProgressBar;
